<template>
  <section class="detail-section" :style="{backgroundImage:'url(' + bgImg + ')'}">
    <div class="overlay"></div>
    <div class="profile-cover-content">
      <div class="container">
        <h2>{{ title }}</h2>
        <h3 v-if="desc">{{ desc }}</h3>
      </div>
    </div>
  </section>
</template>
<script lang="js">
export default {
  name: 'JobBanner',
  props: ['title', 'desc'],
  data: function () {
    return {
      bgImg: '/img/shutterstock_1794608299.jpg'
    }
  }
}
</script>